<template>
	<!-- VIEW RECEIPTS -->
	<div id="page-content" class="supplier-sidebar">
		
		<div v-if="!showr" class="text-center pcsp">
			<h1>You have not made any purchases yet</h1>
			<p>this page displays all receipts click cart to view cart</p>
			<router-link to="/products" class="button-type-h">Start Shopping!</router-link>
		</div>

		<div v-if="showr" class="pcsp">

			<h1 style="display: inline-block;">My Receipts</h1>

			<table style="width: 100%;">
				<tr>
					<th>Order Code:</th>
					<th>Date:</th>
					<th class="text-right">Price:</th>
					<th>Receipt:</th>
				</tr>

				<tr v-for="order in ordersinfo">
					<td>{{ order.order_no }}</td>
					<td>{{ order.order_date.split(" ").shift() }}</td>
					<td class="text-right">Php {{ formatMoney(order.price) }}</td>
					<td class="admin-table-row-options">
						<button @click="viewreceipt(order.order_no)">View</button>
					</td>
				</tr>
				
			</table>

			<transition name="fade">
				<orderreceipt v-if="showReceipt" :orderinfo="orderinfo" :ordercode="currentOrderCode" @exitReceipt="exitReceipt"></orderreceipt>
			</transition>

			<button type="button" class="button-type-f text-left" style="margin-top: 30px;">Export Receipts</button>
		</div>
	</div>
</template>

<script>
	import OrderReceipt from './OrderReceipt.vue';
	export default{
		props: ['issessionset'],
		data(){
			return{
				showr: false,
				ordersinfo: [],

				showReceipt: false,
				orderinfo: [],
				currentOrderCode: ''
			}
		},
		methods:{

			formatMoney: formatMoney,

			viewreceipt: function(ordercode){
				var self = this;
				$.ajax({
					url: 'static/php/orders.php',
					data: {ordercode: ordercode},
					success: function(data){
						data = JSON.parse(data);
						self.orderinfo = data;
						self.currentOrderCode = ordercode;
						self.showReceipt = true;
					}
				});
			},
			exitReceipt: function(event){
				this.showReceipt = false;
			}
		},
		watch: {
			issessionset: function(newval){
				var self = this;
				if(newval === true){
					$.ajax({
						url: 'static/php/orders.php',
						success: function(data){
							data = JSON.parse(data);
							if(!data.length < 1){
								self.ordersinfo = data;
								self.showr = true;
							}
						}
					});
				}else{
					this.$router.push({path: '/login'});
				}
			}
		},
		created(){
			var self = this;
			if(this.issessionset === true){
				$.ajax({
					url: 'static/php/orders.php',
					success: function(data){
						data = JSON.parse(data);
						//additional validation over here 
						if(!data.length < 1){
							self.ordersinfo = data;
							self.showr = true;
						}
					}
				});
			}else{
				this.$router.push({path: '/login'});
			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		},
		components: {
			'orderreceipt': OrderReceipt
		}
	}
</script>


// WEBPACK FOOTER //
// User.vue?1b758e34